import { useMutation } from '@tanstack/react-query';
import type { VerifyEmailInput } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';

interface VerifyEmailApiResponse {
  success: boolean;
  data: { message: string };
}

/**
 * Mutation hook for verifying user's email.
 * Calls POST /auth/verify-email.
 */
export function useVerifyEmail() {
  return useMutation<void, Error, VerifyEmailInput>({
    mutationFn: async (input) => {
      await apiClient.post<VerifyEmailApiResponse>('/auth/verify-email', input);
    },
  });
}
